/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  Component,
  Vue,
} from 'vue-property-decorator';

@Component
export default class WithDeviceType extends Vue {
  private isMobileDevice: boolean = false;
  private mediaQueryList = window.matchMedia('(min-width: 768px)');

  public created() {
    this._updateDeviceType();
    this.mediaQueryList.addListener(this._updateDeviceType);
  }

  public beforeDestroy() {
    this.mediaQueryList.removeListener(this._updateDeviceType);
  }

  private _updateDeviceType() {
    this.isMobileDevice = !this.mediaQueryList.matches;
  }

  get isMobile() {
    return this.isMobileDevice;
  }

  get isDesktop() {
    return !this.isMobileDevice;
  }
}
